import { Auth } from 'aws-amplify';


export const state = {
  currentUser: null
}

export const mutations = {
  SET_CURRENT_USER(state, userSession) {
    state.currentUser = userSession;
    sessionStorage.setItem('authUser', JSON.stringify(userSession));
    localStorage.setItem('userData', JSON.stringify(userSession));

    console.log('Storage set');
  },
  CLEAR_CURRENT_USER(state) {
    state.currentUser = null;
    sessionStorage.removeItem('authUser');
    localStorage.removeItem('userData');
    localStorage.removeItem('userAccess');
  }
}

export const getters = {
  loggedIn(state) {
    return !!state.currentUser
  }
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) { },

  // Logs in the current user.
  // eslint-disable-next-line no-unused-vars
  logIn({ commit, dispatch, getters }, { username, password } = {}) {
    return new Promise((resolve, reject) => {
      Auth.signIn(username, password)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // Logs out the current user.
  // eslint-disable-next-line no-unused-vars
  logOut({ commit }) {
    Auth.signOut();
  },

  // eslint-disable-next-line no-unused-vars
  register({ commit, dispatch, getters }, { username, password, email, phone_number, name, captcha } = {}) {
    return new Promise((resolve, reject) => {
      Auth.signUp({
        username,
        password,
        attributes: {
          email,
          name,
          'phone_number': '',
          'custom:mobile_number': phone_number
        },
        validationData: {
          captcha: captcha
        }
      })
        .then(res => {
          console.log(res);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        })
    });
  },

  // eslint-disable-next-line no-unused-vars
  isUserAvailable({ commit, dispatch, getters }, username) {
    const code = '000000'
    
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
      Auth.confirmSignUp(username, code, {
        forceAliasCreation: false
      }).then(data => console.log(data))
        .catch(err => {
          switch (err.code) {
            case 'UserNotFoundException':
              return resolve(true);
            case 'NotAuthorizedException':
              return resolve(false);
            case 'AliasExistsException':
              return resolve(false);
            case 'CodeMismatchException':
              return resolve(false);
            case 'ExpiredCodeException':
              return resolve(false);
            default:
              return resolve(false);
          }
        })
    });
  },

  // eslint-disable-next-line no-unused-vars
  resendCode({ commit }, username) {
    return new Promise((resolve, reject) => {
      Auth.resendSignUp(username)
        .then(res => resolve(res))
        .catch(err => reject(err))
    });
  },

  // eslint-disable-next-line no-unused-vars
  confirm({ commit, dispatch, getters }, { username, code } = {}) {
    return new Promise((resolve, reject) => {
      console.log({
        username,
        code
      });

      Auth.confirmSignUp(username, code)
        .then(res => {
          console.log(res);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  forgotPassword({ commit }, username) {
    return new Promise((resolve, reject) => {
      Auth.forgotPassword(username)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  },

  // eslint-disable-next-line no-unused-vars
  resetPassword({ dispatch, getters }, { username, code, newPassword } = {}) {
    return new Promise((resolve, reject) => {
      Auth.forgotPasswordSubmit(username, code, newPassword)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  async changeUserPassword({ commit }, params) {
    return new Promise((resolve, reject) => {
      Auth.currentAuthenticatedUser()
        .then(async user => {
          try {
            
            if (params.currentPassword === params.newPassword) {
              return reject({ status: 'err', message: 'New password must be different from the current password.', errorCode: 'OldPasswordMatchesException'});
            }
            const data = await Auth.changePassword(user, params.currentPassword, params.newPassword);
            console.log(data);
            resolve({ status: 'ok', message: `You've successfully updated your password.` });
          } catch (err) {
            console.log(err);
            let errorMessage = 'An error occurred while changing password.';
    
            switch (err.code) {
              case 'NotAuthorizedException':
                errorMessage = 'Your password is incorrect.';
                break;
              case 'LimitExceededException':
                errorMessage = 'Maximum password change attempts reached. Please try again later.';
                break;
              case 'InvalidParameterException':
                errorMessage = 'You have reached the maximum attempts to change password. Please try again later.';
                break;
            }
    
            reject({ status: 'err', message: errorMessage, errorCode: err.code });
          }
        })
        .catch(error => {
          console.log(error);
          reject({ status: 'err', message: 'An error occurred while getting authenticated user.' });
        });
    });
  }
  
  
}